import { useQuery } from 'react-query';

import config from '../config';

import { useAlertsApi } from './api';

export default function useAlerts(userId: string) {
  const api = useAlertsApi();
  const { data, isFetched, isFetching, isLoading, refetch } = useQuery(
    [config.queryKeys.userAlerts],
    () => {
      return api.getAlerts(userId);
    }
  );
  return {
    isFetched,
    isFetching,
    isLoading,
    refetch,
    alerts: data?.alerts ?? [],
    dismissAlert: async (alertId: string) => {
      try {
        await api.dismissAlert(alertId);
        refetch();
      } catch (error) {
        console.warn(error);
      }
    },
    clickedAlert: async (alertId: string) => {
      try {
        await api.clickedAlert(alertId);
      } catch (error) {
        console.warn(error);
      }
    },
  };
}
